import React from 'react'
import PropTypes from 'prop-types'
import Modal from 'reactstrap/lib/Modal'
import ModalBody from 'reactstrap/lib/ModalBody'
import ModalHeader from 'reactstrap/lib/ModalHeader'
import { get } from 'lodash'
import { toast } from 'react-toastify'
import Uploader from '../uploads/Uploader'

const initialState = {
  progressEvent: {},
  uploadPercentage: 0,
  uploadedAttachmentURL: '',
  attachmentFile: {}
}

class UploadAttachment extends React.Component {
  constructor( props ) {
    super( props )
    this.inputRef = React.createRef()
    this.closeModal = this.closeModal.bind( this )
    this.uploadAttachment = this.uploadAttachment.bind( this )
    this.onUploadError = this.onUploadError.bind( this )
    this.onUploadProgress = this.onUploadProgress.bind( this )
    this.onUploadSuccess = this.onUploadSuccess.bind( this )
    this.state = initialState
  }

  closeModal () {
    const { onClose } = this.props
    this.setState( initialState )
    onClose()
  }

  createAttachmentNode ( attachmentURL ) {
    const { attachmentFile } = this.state
    const node = document.createElement( 'div' )
    const link = document.createElement( 'a' )
    const space = document.createElement( 'br' )

    link.innerText = attachmentFile.name
    link.href = attachmentURL
    link.target = '_blank'

    node.appendChild( link )
    node.append( space )
    return node
  }

  handleSubmit = ( e ) => {
    e.preventDefault()
    const { onClick } = this.props
    const { uploadedAttachmentURL } = this.state

    const attachmentNode = this.createAttachmentNode( uploadedAttachmentURL )
    if ( uploadedAttachmentURL ) {
      onClick( attachmentNode )
      this.setState( initialState )
    }
  };

  onUploadProgress ( progressEvent ) {
    if ( progressEvent ) {
      this.setState( { progressEvent } )
      this.setState( {
        uploadPercentage: Math.trunc(
          100 * ( progressEvent.loaded / progressEvent.total )
        )
      } )
    }
  }

  onUploadSuccess ( response ) {
    this.setState( {
      uploading: false,
      uploadedAttachmentURL:
        response.data.src || response.request.responseURL.split( '?' )[0]
    } )
  }

  onUploadError ( error ) {
    this.setState( { uploading: false } )
    const status = get( error, 'response.status' )
    let message = 'Ocorreu um erro e não foi possível submeter o arquivo.'
    if ( status === 400 ) {
      message = get( error, 'response.data.file.0' ) || message
    }
    toast.error( message )
  }

  async uploadAttachment ( event ) {
    const file = get( event, 'target.files.0' )
    const fileSizeLimit = 1024 * 1024 * 10
    if ( file ) {
      if ( file.size > fileSizeLimit ) {
        toast.error(
          `Tamanho do arquivo não pode ser mais que 10Mb.`
        )
        return
      }

      this.setState( { uploading: true, attachmentFile: file } )
      const uploader = new Uploader( {
        file: file,
        onUploadProgress: this.onUploadProgress,
        onSuccess: this.onUploadSuccess,
        onError: this.onUploadError
      } )
      uploader.upload()
    }
  }

  render () {
    const { isOpen } = this.props

    return (
      <Modal isOpen={isOpen} toggle={this.closeModal}>
        <ModalHeader toggle={this.closeModal}>Upload Anexo</ModalHeader>
        <ModalBody>
          <br />
          <label>
            {' '}
            Selecione um anexo:{' '}
          </label>
          <input type="file" name="file" onChange={this.uploadAttachment} />
          <label>Status: {this.state.uploadPercentage}%</label>
          <br />
          <br />
          <button
            type="submit"
            className="btn primary-button pull-right"
            disabled={this.state.uploadPercentage === 100 ? false : true}
            onClick={this.handleSubmit}
          >
            salvar
          </button>
          <button
            type="button"
            className="btn btn-sm btn-white"
            onClick={this.closeModal}
          >
            cancelar
          </button>
        </ModalBody>
      </Modal>
    )
  }
}
UploadAttachment.propTypes = {
  isOpen: PropTypes.bool,
  onClick: PropTypes.func,
  onClose: PropTypes.func
}

UploadAttachment.defaultProps = {
  isOpen: false,
  onClick: () => { },
  onClose: () => { }
}

export default UploadAttachment
